// extracted by mini-css-extract-plugin
export var fadeIn = "_f4-1";
export var modalContent = "_f4-3";
export var overlay = "_f4-0";
export var popoverContent = "_f4-2";
export var results = "_f4-5";
export var searchInputWrapper = "_f4-4";